import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableFooter, TableBody, TableHead, Table, TableSortLabel, TableRow, Typography, TableCell } from "@mui/material";
import { toArray, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { isNullOrWhiteSpace, printf, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { equals, createObj, int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { toDateOnlyStr } from "../Locale.js";
import { Orders_OrderType__get_Id, Orders_OrderType, Orders_OrderType_FromId_Z524259A4, Orders_OrderType__ToLocalizedString_12C6553D } from "../Shared/Shared.js";
import { InvoicePopup } from "./InvoicePopupButton.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { sortFn, formatMoney } from "../Utils.js";
import { map, sumBy } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { loadingIndicatorSmall } from "../ViewHelpers.js";

function Row(rowInputProps) {
    let elements_2;
    const entry = rowInputProps.entry;
    const showMachine = rowInputProps.showMachine;
    const customerId = rowInputProps.customerId;
    const key = rowInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const invoiceDate = parse(entry.Date);
    const td$0027 = (text) => MuiHelpers_createElement(TableCell, [["variant", "body"], ["children", MuiHelpers_createElement(Typography, [["variant", "body2"], ["children", text]])]]);
    return MuiHelpers_createElement(TableRow, [["hover", true], (elements_2 = toList(delay(() => {
        let elements;
        return append(singleton(MuiHelpers_createElement(TableCell, [["size", "small"], (elements = [createElement("a", {
            target: "_blank",
            href: toText(printf("/customer/%i/invoice/%i"))(customerId)(entry.InvoiceNumber),
            children: ctx.Locale.t("History.View"),
        })], ["children", reactApi.Children.toArray(Array.from(elements))])])), delay(() => append(singleton(td$0027(int32ToString(entry.InvoiceNumber))), delay(() => append(singleton(td$0027(toDateOnlyStr(ctx.DateFnsLocale, invoiceDate))), delay(() => append(singleton(td$0027(Orders_OrderType__ToLocalizedString_12C6553D(Orders_OrderType_FromId_Z524259A4(entry.Type), ctx.Language))), delay(() => append(showMachine ? singleton(td$0027(entry.Machine)) : empty(), delay(() => append(singleton(td$0027(entry.Details)), delay(() => {
            let elements_1, elems_1;
            return append(singleton(MuiHelpers_createElement(TableCell, [["variant", "body"], (elements_1 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
            }], (elems_1 = toList(delay(() => append(!isNullOrWhiteSpace(entry.InvoiceComment) ? singleton(createElement(InvoicePopup, entry)) : empty(), delay(() => singleton(MuiHelpers_createElement(Typography, [["sx", {
                maxWidth: 50 + "ch",
            }], ["noWrap", true], ["children", entry.InvoiceComment]])))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elements_1))])])), delay(() => singleton(MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["align", "left"], ["children", formatMoney(ctx.Language, entry.Amount)]]))));
        }))))))))))));
    })), ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

export function Invoice_Table_Z54DF4752(invoice_Table_Z54DF4752InputProps) {
    let elems, elements_5, children_1, elements_2, elements_4, elements_3;
    const machineIdOpt = invoice_Table_Z54DF4752InputProps.machineIdOpt;
    const entries = invoice_Table_Z54DF4752InputProps.entries;
    const customerId = invoice_Table_Z54DF4752InputProps.customerId;
    const orderType = invoice_Table_Z54DF4752InputProps.orderType;
    const year = invoice_Table_Z54DF4752InputProps.year;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setAsc = patternInput[1];
    const asc = patternInput[0];
    const patternInput_1 = reactApi.useState("Date");
    const sortKey = patternInput_1[0];
    const th$0027 = (keyOpt, label) => {
        let key_3;
        return MuiHelpers_createElement(TableCell, [["style", {
            fontWeight: "bold",
        }], ["variant", "head"], ["children", (keyOpt != null) ? ((key_3 = keyOpt, MuiHelpers_createElement(TableSortLabel, toList(delay(() => append(singleton(["onClick", (_arg) => {
            if (sortKey === key_3) {
                setAsc(!asc);
            }
            else {
                setAsc(true);
                patternInput_1[1](key_3);
            }
        }]), delay(() => append(asc ? singleton(["direction", "asc"]) : singleton(["direction", "desc"]), delay(() => append(singleton(["active", key_3 === sortKey]), delay(() => singleton(["children", label])))))))))))) : label]]);
    };
    const headers = toArray(delay(() => append(singleton(th$0027(undefined, "Vis")), delay(() => append(singleton(th$0027("InvoiceNumber", ctx.Locale.t("History.Invoice"))), delay(() => append(singleton(th$0027("Date", ctx.Locale.t("History.Date"))), delay(() => append(singleton(th$0027("Type", "Type")), delay(() => append((machineIdOpt == null) ? singleton(th$0027("Mahine", ctx.Locale.t("Machine"))) : empty(), delay(() => append(singleton(th$0027("Details", ctx.Locale.t("History.Details"))), delay(() => append(singleton(th$0027("Comment", ctx.Locale.t("History.Comment"))), delay(() => singleton(th$0027("Amount", `${ctx.Locale.t("History.Amount")} (eks. MVA)`))))))))))))))))));
    if (entries != null) {
        const entries_1 = entries;
        if (entries_1.length === 0) {
            return createElement("div", createObj(ofArray([["style", {
                textAlign: "center",
                marginTop: 20,
            }], (elems = [createElement("span", {
                style: {
                    fontStyle: "italic",
                },
                children: `${ctx.Locale.t("History.NoOrders")} ${year}`,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }
        else {
            const filtered = entries_1.filter((entry) => {
                if (equals(orderType, new Orders_OrderType(0, []))) {
                    return true;
                }
                else {
                    return entry.Type === Orders_OrderType__get_Id(orderType);
                }
            });
            const sumYear = sumBy((invoice) => invoice.Amount, filtered, {
                GetZero: () => 0,
                Add: (x, y) => (x + y),
            });
            const sorted = sortFn(asc, sortKey)(filtered);
            return MuiHelpers_createElement(Table, [(elements_5 = [(children_1 = singleton_1(MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(headers))]])), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), MuiHelpers_createElement(TableBody, [(elements_2 = map((entry_1) => {
                const $keyZ673C1C70 = entry_1.InvoiceNumber | 0;
                return createElement(Row, {
                    key: $keyZ673C1C70,
                    $key: $keyZ673C1C70,
                    customerId: customerId,
                    showMachine: machineIdOpt == null,
                    entry: entry_1,
                });
            }, sorted), ["children", reactApi.Children.toArray(Array.from(elements_2))])]), MuiHelpers_createElement(TableFooter, [(elements_4 = [MuiHelpers_createElement(TableRow, [(elements_3 = [MuiHelpers_createElement(TableCell, [["colSpan", headers.length - 1], ["children", MuiHelpers_createElement(Typography, [["children", `${ctx.Locale.t("History.Amount")} (eks. MVA)`]])]]), MuiHelpers_createElement(TableCell, [["children", MuiHelpers_createElement(Typography, [["children", formatMoney(ctx.Language, sumYear)]])]])], ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elements_5))])]);
        }
    }
    else {
        return loadingIndicatorSmall();
    }
}

